export enum MessageTypes {
    REQUEST_SECURE_SYNC = 0,
    LOAD_COMPLETE = 1,
    UPDATE_COMPLETE = 2,
    UNAUTHORIZED = 3,
    FORBIDDEN = 4,
    INTERNAL_ERROR = 5,
    NOT_FOUND = 6,
    UNKNOWN = 7,
    CONFIGURATION = 8,
    /** Posted by the sync worker when a newer build upgraded the cache database; the window must reload. */
    RELOAD_REQUIRED = 9,
    /**
     * Posted by the sync supervisor per content key: `payload` is the product key, `ok` whether the key's sync reached
     * the server (absent when it did not run this pass), `at` when it last did (epoch ms, or null if never).
     */
    SYNC_STATUS = 10
}
